import React from 'react'
import css from './style.scss'

export default ({ children }) => (
  <div className={css.metricsSubcards}>
    {children}
  </div>
)
